import React from 'react'
import { Link } from 'react-router-dom'

import PrivacyPolicy from '../../pages/PrivacyPolicy';
import TermsConditions from '../../pages/TermsConditions';

const Footer = () => {
  return (
    <>
    {/* <div className='w-full py-[0.4px] bg-gradient-to-r from-[#111111] via[#242424] to-[#dfdfdf] mt-32'></div> */}
        <div className='sm:flex space-y-2 sm:space-y-0 w-full items-center justify-between py-3 leading-10 text-slate-400'>
            <div className='text-sm font-sans'>© 2024. Tracklimo Pvt Ltd. All rights reserved.</div>
            <div className='flex items-center justify-end space-x-5 text-sm font-sans'>
                <Link to="/TermsConditions">Terms and Conditions</Link>
                <Link to="/PrivacyPolicy">Privacy Policy</Link>
            </div>
        </div>
    </>
  )
}

export default Footer